// src/config/menu.js
import {
  DashboardTwoTone,
  AppstoreTwoTone,
  DollarTwoTone,
  CrownTwoTone,
  SettingTwoTone,
} from '@ant-design/icons';

export const MenuList = [
  { key: 'dashboard', icon: <DashboardTwoTone style={{fontSize:'16px'}} />, label: 'Dashboard', to: '/dashboard' },
  {
    key: 'manage room',
    icon: <AppstoreTwoTone style={{fontSize:'16px'}} />,
    label: 'Manage Rooms',
    to: '/manage-rooms',
    children: [
      { key: 'book', label: 'Onsite Booking', to: '/book-room' },
      { key: 'book', label: 'Online Booking', to: '/online-book' },
      { key: 'room', label: 'Manage Rooms', to: '/manage-rooms' },
      { key: 'amenities', label: 'Amenities', to: '/manage-amenities' },
      { key: 'room_type', label: 'Room Type', to: '/manage-room-type' },
      { key: 'room history', label: 'Room History', to: '/room-history' },
      // { key: 'seasonal price', label: 'Seasonal Princing Management', to: '/seasonal-princing-management' },
    ]
  },
  {
    key: 'Expense',
    icon: <DollarTwoTone style={{fontSize:'16px'}}/>,
    label: 'Expense',
    to: '/expense',
    children: [
      { key: 'Manage exx', label: 'Expense Tracker', to: '/expense' },
      { key: 'service exx', label: 'Service Requests', to: '/service-requests' },
      { key: 'conig', label: 'Manage Expense', to: '/manage-expense' },
    ]
  },
 
  // {
  //   key: 'reports',
  //   icon: <DropboxOutlined />,
  //   label: 'Manage Reports',
  //   to: '/manage-report',
  // },
  {
    key: 'Configurations',
    icon: <SettingTwoTone style={{fontSize:'16px'}}/>,
    label: 'Configurations',
    to: '/configurations',
    children: [
      { key: 'Media Library', label: 'Media Library', to: '/media-library' },
      { key: 'policies', label: 'Policies', to: '/policies' },
      { key: 'in-house-services', label: 'In-House Services', to: '/in-house-services' },
      { key: 'user access', label: 'User Access', to: '/user-access' },
              { key: 'user-permissions', label: 'User Permissions', to: '/user-permissions' },

      { key: 'settings', label: 'Settings', to: '/settings' },
    ]
  },
  {
    key: 'customer',
    icon: <CrownTwoTone style={{fontSize:'16px'}}/>,
    label: 'Manage Customer and loyality',
    children: [
      { key: 'customer', label: 'Manage Customers', to: '/customers' },
      { key: 'loyality-programe', label: 'Loyalty Programe', to: '/loyalty' },
    ]
  },

];